<template>
  <el-row :gutter="15">
    <el-col :md="4">
      <Filters
        v-model="filters"
        :resource="$sdk.invoice"
        :primary-fields="['account', 'date', 'status']"
        @ready="loadInvoices()"
        @apply="loadInvoices()"
      />
    </el-col>
    <el-col :md="20">
      <el-card v-loading="isLoading">
        <InvoiceTable :invoices="invoices" />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import InvoiceTable from '@/components/Application/Billing/Invoices/Table'
import Filters from '@/components/Filters/Simplified'

export default {
  components: {
    InvoiceTable,
    Filters
  },
  data () {
    return {
      breadcrumb: {
        name: 'Invoices',
        route: { name: 'billing-invoices' }
      },
      invoices: [],
      isLoading: [],
      filters: []
    }
  },
  methods: {
    loadInvoices () {
      this.isLoading = true
      this.$sdk.invoice.list(builder => {
        builder.filters = this.filters
        builder.order = 'invoice_id:desc'
      }).then(res => {
        this.invoices = res
        this.isLoading = false
      })
    }
  }
}
</script>
